import type { ResolvedTheme, ThemePreference } from "./types";

export const DARK_CLASS = "dark";
export const PREFERS_DARK_QUERY = "(prefers-color-scheme: dark)";

export function resolveTheme(
  preference: ThemePreference,
  systemPrefersDark: boolean
): ResolvedTheme {
  if (preference === "system") return systemPrefersDark ? "dark" : "light";
  return preference;
}

export function systemPrefersDark(): boolean {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function")
    return false;
  return window.matchMedia(PREFERS_DARK_QUERY).matches;
}

/**
 * Paints the theme: Tailwind's `dark:` variant and every `.dark {}` token
 * block key off the class on `<html>`; `color-scheme` flips native scrollbars,
 * form controls and date pickers to match.
 */
export function applyResolvedTheme(theme: ResolvedTheme): void {
  if (typeof document === "undefined") return;
  const root = document.documentElement;
  root.classList.toggle(DARK_CLASS, theme === "dark");
  root.style.colorScheme = theme;
}
